import Layout from "../../Internal/Layout.vue";
import InstallersPage from "./Installers.vue";
import InstallersAdd from "../Installers/InstallersAdd/InstallersAdd.vue";
import InstallersProfile from "../Installers/InstallersProfile/InstallersProfile.vue";
import InstallersConfig from "../Installers/InstallersConfig/InstallersConfig.vue";
import InstallersService from "../Installers/InstallersService/InstallersService.vue";

const InstallersRoutes = {
  component: Layout,
  children: [
    {
      path: "/installers",
      name: "Installers",
      component: InstallersPage,
      meta: {
        requiresMaster: true,
        requiresAuth: true,
        requiresAdmin: true,
        requiresInstaller: true,
        requiresImprimaxtec: true,
      },
    },

    {
      path: "/add-installer",
      name: "InstallersAdd",
      component: InstallersAdd,
      meta: {
        requiresMaster: true,
        requiresAuth: true,
        requiresAdmin: true,
        requiresInstaller: true,
        requiresImprimaxtec: true,
      },
    },

    {
      path: "/profile-installer",
      name: "InstallersProfile",
      component: InstallersProfile,
      meta: {
        requiresMaster: true,
        requiresAuth: true,
        requiresAdmin: true,
        requiresInstaller: true,
        requiresImprimaxtec: true,
      },
    },

    {
      path: "/installers-config",
      name: "InstallersConfig",
      component: InstallersConfig,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresInstaller: true,
      },
    },

    {
      path: "/installers-service",
      name: "InstallersService",
      component: InstallersService,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresInstaller: true,
      },
    },
  ],
};

export default InstallersRoutes;
